import { SHOW_HEADBAND, HIDE_HEADBAND } from '../actions/headband';

export const showHeadband = meta => async dispatch => {
  const timestamp = Date.now();
  dispatch({
    type: SHOW_HEADBAND,
    meta,
    timestamp,
  });
};

export const hideHeadband = meta => async dispatch => {
  const timestamp = Date.now() + 35000;
  dispatch({
    type: HIDE_HEADBAND,
    timestamp,
  });
};
